import { isIdXboxGameInformationGameExpectationsValid } from "../../../../helpers/formValidation";
import { hasHandheldOptimizationRequiredPlatform } from "../../../../helpers/handheldOptimizationHelpers";
import { hasXboxPlayAnywhereRequiredPlatforms } from "../../../../helpers/xboxPlayAnywhereHelpers";
import { OnboardingErrorMessage } from "../../../../models/errors";
import {
  GameInformationGameExpectationsDataType,
  SubFormsDataTypes,
} from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const GameExpectationsDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const gameExpectationsData = data as GameInformationGameExpectationsDataType;
    if (!gameExpectationsData) {
      return { result: true };
    }

    const validSchema = await isIdXboxGameInformationGameExpectationsValid(gameExpectationsData);
    const validXboxPlayAnywherePlatforms = hasXboxPlayAnywhereRequiredPlatforms(
      gameExpectationsData.xboxPlayAnywhere,
      gameExpectationsData.targetPlatforms
    );
    const validHandheldOptimizationPlatform = hasHandheldOptimizationRequiredPlatform(
      gameExpectationsData.handheldOptimization,
      gameExpectationsData.targetPlatforms
    );
    return {
      result: validSchema && validXboxPlayAnywherePlatforms && validHandheldOptimizationPlatform,
      message: !validXboxPlayAnywherePlatforms
        ? OnboardingErrorMessage.xboxPlayAnywherePlatformsRequired
        : !validHandheldOptimizationPlatform
        ? OnboardingErrorMessage.handheldOptimizationPlatformRequired
        : undefined,
    };
  },
};
